const allowedOrigins = [
    'https://foroempleo-ufv.dev.doubledot.es',
    'http://localhost:8080',
    'https://foroempleo-ufv-migration.dev.doubledot.es',
    'https://portalforoempleo.ufv.es'
    // Aquí la url en PRO del foro
];


export function handleMessage(event) {
    if (!allowedOrigins.includes(event.origin)) {
        console.warn('Origen no autorizado:', event.origin);
        return;
    }

    const { token, receptor, user } = event.data;
    if (token && receptor &&  user) {
        this.token = token;
        this.urlDestino = receptor
        localStorage.setItem('_token', token);
        localStorage.setItem('_userType', user);
        localStorage.setItem('_urlForo', receptor);
        window.location.href = receptor
    } else {
        console.warn('No se recibió datos válidos.');
    }
};


// WEBPACK FOOTER //
// ./src/validator/handleForumMsg.js